import { c as _c } from "react-compiler-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useModal } from '@nike/podium-dialog-manager';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import Message from "../message/Message";
import Modal from "../modal/Modal";
import useErrorModalStore from "../../store/error-modal/use-store";
import releaseScrollLock from "../../utils/release-scroll-lock";
var ErrorWarningModal = function ErrorWarningModal(t0) {
  var $ = _c(28);
  var errorsToExclude = t0.errorsToExclude;
  var _useErrorModalStore = useErrorModalStore(_temp),
    error_0 = _useErrorModalStore.error,
    clearError_0 = _useErrorModalStore.clearError;
  var _useModal = useModal(true),
    isOpen = _useModal.isOpen,
    openModal = _useModal.openModal,
    closeModal = _useModal.closeModal;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "error.errorMessage.header",
      primaryValue: "Error",
      description: "Error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var errorTitle = useI18nString(t1);
  var hasTrackedError = useRef(false);
  var t2;
  if ($[1] !== error_0) {
    t2 = function t2() {
      if (error_0 && !hasTrackedError.current) {
        hasTrackedError.current = true;
        window.webShellClient.analytics.trackAction({
          underlyingAction: {
            "case": "coreCommerceV1ErrorMessageViewed",
            value: {
              errorMessage: {
                error: {
                  "case": "nikeApiError",
                  value: {
                    serviceCode: error_0 === null || error_0 === void 0 ? void 0 : error_0.code,
                    errorCode: error_0 === null || error_0 === void 0 ? void 0 : error_0.crcCode
                  }
                }
              }
            }
          }
        }, {
          eventVersion: 2
        });
      }
    };
    $[1] = error_0;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  var t3 = error_0 === null || error_0 === void 0 ? void 0 : error_0.code;
  var t4 = error_0 === null || error_0 === void 0 ? void 0 : error_0.crcCode;
  var t5;
  if ($[3] !== error_0 || $[4] !== t3 || $[5] !== t4) {
    t5 = [error_0, t3, t4];
    $[3] = error_0;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t2, t5);
  var t6;
  if ($[7] !== closeModal || $[8] !== error_0 || $[9] !== errorsToExclude || $[10] !== isOpen || $[11] !== openModal) {
    t6 = function t6() {
      var errorCrcCode = error_0 === null || error_0 === void 0 ? void 0 : error_0.crcCode;
      var shouldExcludeError = errorsToExclude && errorCrcCode && errorsToExclude.includes(errorCrcCode);
      var shouldOpen = Boolean(error_0) && !shouldExcludeError;
      if (shouldOpen && !isOpen) {
        openModal();
      } else {
        if (!shouldOpen && isOpen) {
          closeModal();
        }
      }
    };
    $[7] = closeModal;
    $[8] = error_0;
    $[9] = errorsToExclude;
    $[10] = isOpen;
    $[11] = openModal;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  var t7 = error_0 === null || error_0 === void 0 ? void 0 : error_0.crcCode;
  var t8;
  if ($[13] !== closeModal || $[14] !== error_0 || $[15] !== errorsToExclude || $[16] !== isOpen || $[17] !== openModal || $[18] !== t7) {
    t8 = [error_0, isOpen, openModal, closeModal, t7, errorsToExclude];
    $[13] = closeModal;
    $[14] = error_0;
    $[15] = errorsToExclude;
    $[16] = isOpen;
    $[17] = openModal;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  useEffect(t6, t8);
  var t9;
  if ($[20] === Symbol["for"]("react.memo_cache_sentinel")) {
    t9 = [];
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useEffect(_temp3, t9);
  var t10;
  if ($[21] !== clearError_0) {
    t10 = function t10() {
      releaseScrollLock();
      clearError_0();
    };
    $[21] = clearError_0;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  var handleClose = t10;
  var t11;
  if ($[23] === Symbol["for"]("react.memo_cache_sentinel")) {
    t11 = /*#__PURE__*/React.createElement(Message, null);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  var t12;
  if ($[24] !== errorTitle || $[25] !== handleClose || $[26] !== isOpen) {
    t12 = /*#__PURE__*/React.createElement(Modal, {
      isOpen: isOpen,
      onClose: handleClose,
      onOverlayClick: handleClose,
      "data-automation": "cart-error-modal",
      title: errorTitle
    }, t11);
    $[24] = errorTitle;
    $[25] = handleClose;
    $[26] = isOpen;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
ErrorWarningModal.propTypes = {
  onClose: PropTypes.func,
  crcCode: PropTypes.string,
  code: PropTypes.string,
  message: PropTypes.string,
  servicePath: PropTypes.string,
  promoDetail: PropTypes.shape({
    code: PropTypes.string,
    reasons: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.string
    }))
  }),
  hasError: PropTypes.bool,
  errorsToExclude: PropTypes.arrayOf(PropTypes.string)
};
export default ErrorWarningModal;
function _temp(t0) {
  var error = t0.error,
    clearError = t0.clearError;
  return {
    error: error,
    clearError: clearError
  };
}
function _temp2() {
  return releaseScrollLock();
}
function _temp3() {
  return _temp2;
}